import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import {
  CoreDialogMessageEffects,
  CoreErrorTrackEffects,
  CoreSnackbarEffects,
} from './+state';
import { RecaptchaEffects } from './+state/recaptcha';

@NgModule({
  imports: [
    StoreRouterConnectingModule.forRoot(),
    StoreModule.forRoot(
      {
        router: routerReducer,
      },
      {
        metaReducers: [],
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      },
    ),
    EffectsModule.forRoot([]),

    EffectsModule.forFeature([
      CoreDialogMessageEffects,
      CoreSnackbarEffects,
      CoreErrorTrackEffects,
      RecaptchaEffects,
    ]),
  ],
  exports: [StoreRouterConnectingModule, StoreModule, EffectsModule],
})
export class NgrxModule {}
